import { render, staticRenderFns } from "./PreviewNewDiscussionButton.vue?vue&type=template&id=56434062&"
import script from "./PreviewNewDiscussionButton.vue?vue&type=script&lang=js&"
export * from "./PreviewNewDiscussionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PreviewNewDiscussionButton.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/gutters/PreviewNewDiscussionButton.vue
// module id = 2235
// module chunks = 1